<template>
  <v-dialog v-model="show" width="500px">
    <ModalContentSubBukuBesarBulan :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentSubBukuBesarBulan from './ModalContentSubBukuBesarBulan.vue';

export default {
  components: {
    ModalContentSubBukuBesarBulan,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
